import Box from "@mui/material/Box";
import OnboardingAssistanceCta from "./OnboardingAssistanceCta";
import type { OnboardingLayoutProps } from "../types";

const Onboarding = ({ children, ...restProps }: OnboardingLayoutProps) => (
    <Box
        {...restProps}
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            ...restProps.sx
        }}
    >
        <Box
            sx={{
                width: '100%',
                height: '100%',
                maxWidth: 753,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 7
            }}
        >
            {children}
            <OnboardingAssistanceCta />
        </Box>
    </Box>
);

export default Onboarding;
